

export const LOGOUT = "app/LOGOUT";
export const CLOSE_SIDE_NAV = "app/CLOSE_SIDE_NAV";

export const PASSWORD_REGEX = {
  capital: /[A-Z]/,
  digit: /\d/,
  special: /[-._!"`'#%&,:;<>=@{}~\$\(\)\*\+\/\\\?\[\]\^\|]+/,
};

export const PASSWORD_ERROR = {
  minLength: "Length must be greater than 8 characters",
  capital: "Password must contain at least one uppercase letter",
  digit: "Password must contain at least one number",
  special: "Password must contain at least one special character",
};

export const EMAIL_REGEX =
  /^(\s+)?([A-Z0-9._%+-])+@[A-Z0-9.-]+\.[A-Z]{2,}(\s+)?$/i;
export const DEFAULT_REQUIRED_ERROR = "This field is required";
export const DEFAULT_FORMAT_EMAIL_ERROR = "Invalid email address";
export const MAX_LENGTH_255 = "Maximum is 255 characters";

export const SOCIAL_LOGIN_TYPE = {
  GOOGLE: "google",
  FACEBOOK: "facebook",
};

export const initialDays = [
  { id: 2, name: `Monday`, value: 2 },
  { id: 3, name: "Tuesday", value: 3 },
  { id: 4, name: `Wednesday`, value: 4 },
  { id: 5, name: "Thursday", value: 5 },
  { id: 6, name: `Friday`, value: 6 },
  { id: 7, name: "Saturday", value: 7 },
  { id: 8, name: `Sunday`, value: 8 },
];


export const initalBreadCrumbsData = [
  {
    text: "Briklo Home",
    to: "/",
  },
  {
    text: "Briklo Program",
    to: "/",
  },
  {
    text: "",
  },
];

export const weeklyView = [
  { name: `Show Day Number`, value: 0 },
  { name: "Show Day Name", value: 1 },
  // { name: `Don't Show Days`, value: 2 },
];
